// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePassword } from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";

const digitRegExp = /[0-9]/;
const lowerRegExp = /[a-z]/;
const upperRegExp = /[A-Z]/;
const specialRegExp = /\W/;
// XNG-Changes
const notAllowedSpecialCharactersRegExp = /[&%+]/g;

const XngValidatePassword: typeof ValidatePassword = props => {
    let errorMessage: React.ReactNode = "";
    const password = props.parameter.password;
    const {
        passwordMinimumLength,
        passwordRequiresDigit,
        passwordRequiresLowercase,
        passwordRequiresUppercase,
        passwordRequiresSpecialCharacter,
    } = getSettingsCollection(props.getState()).accountSettings;

    if (!password) {
        errorMessage = siteMessage("CreateNewAccountInfo_Password_Required");
    }

    if (!errorMessage && password.length > 0 && password.length < passwordMinimumLength) {
        errorMessage = translate("Password must be at least {0} characters long", passwordMinimumLength.toString());
    }

    if (!errorMessage && passwordRequiresDigit && !digitRegExp.test(password)) {
        errorMessage = translate("Password must include at least one number");
    }

    if (!errorMessage && passwordRequiresLowercase && !lowerRegExp.test(password)) {
        errorMessage = translate("Password must include at least one lowercase character");
    }

    if (!errorMessage && passwordRequiresUppercase && !upperRegExp.test(password)) {
        errorMessage = translate("Password must include at least one uppercase character");
    }

    if (!errorMessage && passwordRequiresSpecialCharacter && !specialRegExp.test(password)) {
        errorMessage = translate("Password must include at least one non alphanumeric character");
    }
    // XNG-Changes
    if (!errorMessage && notAllowedSpecialCharactersRegExp.test(password)) {
        errorMessage = translate("Password cannot contain any of the following special characters: +, %, &");
    }

    props.passwordErrorMessage = errorMessage;
};

replaceInChain(chain, ValidatePassword, XngValidatePassword);
